import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home.jsx";
import AboutMe from "../pages/AboutMe.jsx";
import FindEase from "../pages/FindEase.jsx";
import NoPage from "../pages/NoPage.jsx";
import Projects from "../pages/Projects.jsx";
import ScrollToTop from "./ScrollToTop.jsx";

const AnimRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<AboutMe />} />
        <Route path="/findease" element={<FindEase />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </>
  );
};

export default AnimRoutes;
